import { render, staticRenderFns } from "./CardDadosTerritorio.vue?vue&type=template&id=18bed583&scoped=true&lang=pug"
import script from "./CardDadosTerritorio.vue?vue&type=script&lang=js"
export * from "./CardDadosTerritorio.vue?vue&type=script&lang=js"
import style0 from "./CardDadosTerritorio.vue?vue&type=style&index=0&id=18bed583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bed583",
  null
  
)

export default component.exports